import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { useState } from "react";
import { ToastContainer } from "@/utils/toast.service";

export function AppLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="flex h-screen bg-slate-50 dark:bg-[#09090b] text-slate-900 dark:text-slate-100 overflow-hidden font-sans selection:bg-purple-500/20">
      <ToastContainer />
      <Sidebar
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative">
        <Header onMenuClick={() => setMobileMenuOpen(!mobileMenuOpen)} />
        <main
          className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 dark:bg-slate-950/80 scrollbar-thin scrollbar-thumb-slate-300 dark:scrollbar-thumb-slate-800"
          style={{
            backgroundImage: "url(/candidate-bg.jpg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            backgroundBlendMode: "overlay",
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
